import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Label, Input, Textarea, PrimaryBtn, GhostBtn } from "@/components/admin/ui";
import { Save } from "lucide-react";

export default function HomePanel() {
  const [form, setForm] = useState({ title: "", subtitle: "", hero_image: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/home").then((r) => setForm(r.data)).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/content/home", form);
      toast.success("Home aggiornata");
    } catch {
      toast.error("Errore nel salvataggio");
    } finally {
      setSaving(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="max-w-2xl space-y-5">
      <div>
        <Label>Titolo principale</Label>
        <Input data-testid="home-title" value={form.title || ""} onChange={set("title")} className="mt-2" />
      </div>
      <div>
        <Label>Sottotitolo</Label>
        <Textarea data-testid="home-subtitle" rows={3} value={form.subtitle || ""} onChange={set("subtitle")} className="mt-2" />
      </div>
      <div>
        <Label>URL immagine hero</Label>
        <Input data-testid="home-hero" value={form.hero_image || ""} onChange={set("hero_image")} className="mt-2" />
        {form.hero_image && (
          <img src={form.hero_image} alt="preview" className="mt-3 h-40 w-full object-cover border border-zinc-800" />
        )}
      </div>
      <PrimaryBtn onClick={save} disabled={saving} data-testid="save-home-btn">
        <Save className="h-4 w-4" /> {saving ? "Salvataggio…" : "Salva"}
      </PrimaryBtn>
    </div>
  );
}
